





import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class SimpleAlert extends Vue {}
